import React from "react";
import { Link } from "react-router-dom";

export const Item = ({
  id = "",
  titulo = "",
  imagenes = "",
  precio = "",
  stock = "",
}) => {
  // UNICO CAMBIO: Convertimos el string de la DB a array para que imagenes[0].url no falle
  let imagenesArray = [];
  try {
    imagenesArray =
      typeof imagenes === "string" ? JSON.parse(imagenes || "[]") : imagenes;
  } catch (e) {
    imagenesArray = [];
  }

  return (
    <div className="tienda item pe-2 ps-2" key={id}>
      {/* Mantenemos tu ruta original con el # y el tituloId */}
      <Link to={`/detalle/${id}/`} className="link">
        <div className="cajaDeCajas">
          <div className="imgMedida caja">
            <div className="prueba img-container">
              {/* Usamos el array procesado para evitar el error de undefined */}
              {imagenesArray && imagenesArray.length > 0 ? (
                <img
                  src={imagenesArray[0].url}
                  alt={`Foto de ${titulo}`}
                  className="img-fluid mx-0 px-0"
                />
              ) : (
                <div className="img-fluid mx-0 px-0"></div>
              )}

              <div className={stock === 0 ? "medida no" : "d-none"}>
                <h5>sin stock</h5>
                <p>consultar</p>
              </div>
            </div>
          </div>
          <h4 className="text-center negrita mt-2">{titulo}</h4>
          <p className="text-center negrita pb-2">
            <span className="negrita me-2">
              {/* Aseguramos que precio sea un número para toLocaleString */}$
              {Number(precio).toLocaleString("es-AR")}{" "}
            </span>
          </p>
        </div>
      </Link>
    </div>
  );
};
